const TierBasedCategoryCoins = {
  BEGINNER: {
    2: 0,
    9: 200,
    10: 200,
    11: 200,
    12: 200,
    15: 500,
    16: 10,
    18: 150,
    19: 10,
    25: 150,
    27: 200,
    default: 10,
  },
  PRO: {
    2: 0,
    9: 300,
    10: 300,
    11: 300,
    12: 300,
    15: 750,
    16: 20,
    18: 300,
    25: 300,
    19: 20,
    27: 300,
    default: 20,
  },
  EXPERT: {
    2: 0,
    9: 600,
    10: 600,
    11: 600,
    12: 600,
    15: 1000,
    16: 30,
    18: 700,
    25: 700,
    19: 30,
    27: 600,
    default: 30,
  },
  GENIUS: {
    2: 0,
    9: 1000,
    10: 1000,
    11: 1000,
    12: 1000,
    15: 2000,
    16: 40,
    18: 1000,
    19: 40,
    25: 1000,
    27: 1000,
    default: 40,
  },
}

export { TierBasedCategoryCoins }
